import
{
    Form1
} from "@ews/react-data";

import
{
    FC
} from "react";

import s from '../SystemDocumentation.module.scss';

const TableForm1: FC<{ data: Form1; }> = ({
    data
}) =>
{
    if (!data) return <>no data</>;
    return <table id='system-documentation-form-1' data-name='Formblatt1' className={s.table}>
        <thead>
            <tr>
                <td style={{ width: "30px" }}></td>
                <td style={{ width: "150px" }}></td>
                <td style={{ width: "30px" }}></td>
                <td style={{ width: "150px" }}></td>
                <td style={{ width: "100px" }}></td>
                <td style={{ width: "20px" }}></td>
                <td style={{ width: "20px" }}></td>
                <td style={{ width: "40px" }}></td>
                <td style={{ width: "20px" }}></td>
                <td style={{ width: "50px" }}></td>
                <td style={{ width: "100px" }}></td>
                <td style={{ width: "20px" }}></td>
                <td style={{ width: "40px" }}></td>
                <td style={{ width: "20px" }}></td>
                <td style={{ width: "20px" }}></td>
                <td style={{ width: "40px" }}></td>
                <td style={{ width: "20px" }}></td>

            </tr>
        </thead>
        <tbody>
            <tr>
                <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={10}>Brandmeldeanlage</td>
                <td className={`${s.b} ${s.title}`} colSpan={7}>TRVB 123 S</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`} rowSpan={2} colSpan={10}>Einreichung</td>
                <td className={`${s.bR} ${s.title}`} colSpan={7}>Anhang 1</td>
            </tr>
            <tr>
                <td className={`${s.bR} ${s.title}`} colSpan={7}>Formblatt 1</td>
            </tr>
            <tr>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`}  >1</td>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Überwachtes Objekt</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Anschrift:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.monitoredObject?.address}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Bezeichnung:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.monitoredObject?.description}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Nutzung:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.monitoredObject?.usage}</td>
            </tr>
            <tr>
                <td rowSpan={4} className={`${s.b} ${s.aT} ${s.tL}`}  >2</td>
                <td rowSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Anlagenbetreiber</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Name:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemOperator?.name}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Anschrift:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemOperator?.address}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Tel. Nr.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemOperator?.telephoneNumber}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Email:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemOperator?.email}</td>
            </tr>
            <tr>
                <td rowSpan={5} className={`${s.b} ${s.aT} ${s.tL}`}  >3</td>
                <td rowSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} > Errichterfirma</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Firma:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.constructionCompany?.company}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Anschrift:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.constructionCompany?.address}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Sachbearbeiter.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.constructionCompany?.contactPerson}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Tel. Nr.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.constructionCompany?.telephoneNumber}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Email:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.constructionCompany?.email}</td>
            </tr>
            <tr>
                <td rowSpan={5} className={`${s.b} ${s.aT} ${s.tL}`}  >4</td>
                <td rowSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} >Installationsfirma</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Firma:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.installationCompany?.company}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Anschrift:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.installationCompany?.address}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Sachbearbeiter.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.installationCompany?.contactPerson}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Tel. Nr.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.installationCompany?.telephoneNumber}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Email:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.installationCompany?.email}</td>
            </tr>
            <tr>
                <td rowSpan={8} className={`${s.b} ${s.aT} ${s.tL}`}  >5</td>
                <td rowSpan={8} className={`${s.b} ${s.aT} ${s.tL}`} >Anlage</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >behördlich vorgeschrieben?:</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >ja</td>
                {data.systemInformation?.legallyRequired
                    ? <td className={`${s.b} ${s.aT} ${s.tL}`}>X</td>
                    : <td className={`${s.b} ${s.aT} ${s.tL}`}></td>}
                <td className={`${s.b} ${s.aT} ${s.tL}`} >nein</td>
                {data.systemInformation?.legallyRequired
                    ? <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                    : <td className={`${s.b} ${s.aT} ${s.tL}`}>X</td>}
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >ja</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >nein</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Behörde:</td>
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >Neuinstallation</td>
                {data.systemInformation?.newInstallation ?
                    <td >X</td> : <td></td>
                }
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                {data.systemInformation?.newInstallation ?
                    <td colSpan={2}></td> : <td colSpan={2}>X</td>
                }

                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Zahl:</td>
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >Erweiterung</td>
                {data.systemInformation?.extension ?
                    <td >X</td> : <td></td>
                }
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                {data.systemInformation?.extension ?
                    <td colSpan={2}></td> : <td colSpan={2}>X</td>
                }


                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Datum:</td>
                <td colSpan={5} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >Änderung</td>
                {data.systemInformation?.modification ?
                    <td >X</td> : <td></td>
                }
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                {data.systemInformation?.modification ?
                    <td colSpan={2}></td> : <td colSpan={2}>X</td>
                }

                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Brandschutzkonzept erstellt von:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemInformation?.fireProtectionConceptCreatedBy}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >zuständige Feuerwehr:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemInformation?.responsibleFireDepartment}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Betriebsfeuerwehr:</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >ja</td>
                {data.systemInformation?.companyFireBrigade ?
                    <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>
                }

                <td className={`${s.b} ${s.aT} ${s.tL}`} > / nein</td>
                {data.systemInformation?.companyFireBrigade ?
                    <td className={`${s.b} ${s.aT} ${s.tL}`} ></td> : <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td>
                }

                <td colSpan={8} className={`${s.b} ${s.aT} ${s.tL}`} ></td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Email:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.systemInformation?.email}</td>
            </tr>
            <tr>
                <td rowSpan={6} className={`${s.b} ${s.aT} ${s.tL}`}  >6</td>
                <td rowSpan={6} className={`${s.b} ${s.aT} ${s.tL}`} >Schutzumfang</td>

                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.fullProtection}</td>
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Vollschutz</td>
            </tr>
            <tr>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.fireSectionProtection}</td>
                <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`} >Brandabschnittsschutz</td>
                <td colSpan={6} className={`${s.b} ${s.aT} ${s.tL}`} >Anzahl der Brandabschnitte:</td>
                <td colSpan={6} className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.numberOfFireSections}</td>
            </tr>
            <tr>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.equipmentProtection}</td>
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Einrichtungsschutz</td>
            </tr>
            <tr>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.corridorProtection}</td>
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Gangschutz</td>

            </tr>
            <tr>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.manualAlarming}</td>
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Manuelle Alarmierung</td>

            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Überwachungsfläche der BMA [m²]:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.protectionScope?.monitoredAreaOfFAS_m2} m²</td>
            </tr>
            <tr>
                <td rowSpan={6} className={`${s.b} ${s.aT} ${s.tL}`}  >7</td>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Übertragungsgruppen</td>

                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.transmissionGroups?.transmissionGroupsRingTechnology || 0}</td>
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Übertragungsgruppe(n) in Ringtechnik</td>
            </tr>
            <tr>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.transmissionGroups?.transmissionGroupsSpurTechnology || 0}</td>
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Übertragungsgruppe(n) in Stichtechnik</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Abgezweigte Stiche -</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >Übertragungsgruppe(n)</td>
            </tr>
            <tr>
                <td rowSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Bediengruppen</td>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Mit automatischen Brandmeldern</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.alarmingZones?.automatic || 0}</td>
                <td colSpan={11} className={`${s.b} ${s.aT} ${s.tL}`} >Stück Bediengruppe(n)</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Mit nichtautomatischen Brandmeldern</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`} >{data.alarmingZones?.manual || 0}</td>
                <td colSpan={11} className={`${s.b} ${s.aT} ${s.tL}`} >Stück Bediengruppe(n)</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Insgesamt</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >Stück Bediengruppe(n)</td>
            </tr>
            <tr>
                <td rowSpan={7} className={`${s.b} ${s.aT} ${s.tL}`}  >8</td>
                <td rowSpan={7} className={`${s.b} ${s.aT} ${s.tL}`} >Alarmübertragung</td>

                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >zur alarmannehmenden Stelle:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.alarmTransmission?.toTheAlarmreceivingCenter}</td>
            </tr>
            <tr>

                <td colSpan={15} className={`${s.b} ${s.aT} ${s.tL}`} >Automatisch:</td>
            </tr>
            <tr>
                {data.alarmTransmission?.automaticClass1 ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}

                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Klasse 1 gemäß EN54-21</td>
            </tr>
            <tr>
                {data.alarmTransmission?.automaticClass2 ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Klasse 2 gemäß EN54-21</td>
            </tr>
            <tr>

                <td colSpan={15} className={`${s.b} ${s.aT} ${s.tL}`} >Manuell:</td>
            </tr>
            <tr>
                {data.alarmTransmission?.manualOther ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >durch eine Person:</td>
                <td colSpan={13} className={`${s.b} ${s.aT} ${s.tL}`} >{data.alarmTransmission?.manualByPerson}</td>
            </tr>
            <tr>
                {data.alarmTransmission?.manualByPerson ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}
                <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`} >Sonstiges:</td>
                <td colSpan={13} className={`${s.b} ${s.aT} ${s.tL}`} >{data.alarmTransmission?.manualOther}</td>
            </tr>
            <tr>
                <td rowSpan={4} className={`${s.b} ${s.aT} ${s.tL}`}  >9</td>
                <td rowSpan={4} className={`${s.b} ${s.aT} ${s.tL}`} >Termine</td>

                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Erstbescheiddatum.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.projectMilestones?.initialApprovalDate
                    ? new Date(data.projectMilestones.initialApprovalDate).toLocaleDateString('en-UK', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })
                    : ''}</td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Planungsbeginn ca.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >  {data.projectMilestones?.planningStartApprox
                    ? new Date(data.projectMilestones.planningStartApprox).toLocaleDateString('en-UK', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })
                    : ''}
                </td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Montagebeginn ca.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >  {data.projectMilestones?.installationStartApprox
                    ? new Date(data.projectMilestones.installationStartApprox).toLocaleDateString('en-UK', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })
                    : ''}
                </td>
            </tr>
            <tr>
                <td colSpan={3} className={`${s.b} ${s.aT} ${s.tL}`} >Inbetriebnahme ca.:</td>
                <td colSpan={12} className={`${s.b} ${s.aT} ${s.tL}`} >{data.projectMilestones?.commissioningApprox
                    ? new Date(data.projectMilestones.commissioningApprox).toLocaleDateString('en-UK', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })
                    : ''}</td>
            </tr>

            <tr>
                <td rowSpan={8} className={`${s.b} ${s.aT} ${s.tL}`}  >10</td>
                <td rowSpan={8} className={`${s.b} ${s.aT} ${s.tL}`} >Einreichunterlagen</td>
                {data.submissionDocuments?.controlGroupDirectoryFireAlarmGroups ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}

                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Bedienungsgruppenverzeichnis für Brandmeldegruppen</td>
            </tr>
            <tr>
                {data.submissionDocuments?.controlGroupDirectory1 ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Steuerungsgruppenverzeichnis 1</td>
            </tr>
            <tr>
                {data.submissionDocuments?.controlGroupDirectory2 ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Steuerungsgruppenverzeichnis 2</td>
            </tr>
            <tr>
                {data.submissionDocuments?.controlGroupDirectory3 ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}
                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Steuerungsgruppenverzeichnis 3</td>
            </tr>
            <tr>
                {data.submissionDocuments?.inputs ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}

                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Eingänge</td>
            </tr>
            <tr>
                {data.submissionDocuments?.networkingSubmission ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}

                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Einreichung Vernetzung</td>
            </tr>
            <tr>
                {data.submissionDocuments?.fireProtectionPlans ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}

                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Brandschutzpläne</td>
            </tr>
            <tr>
                {data.submissionDocuments?.certifiedCompanyExecutionConfirmation ? <td className={`${s.b} ${s.aT} ${s.tL}`} >X</td> : <td className={`${s.b} ${s.aT} ${s.tL}`} ></td>}

                <td colSpan={14} className={`${s.b} ${s.aT} ${s.tL}`} >Bestätigung über Ausführung durch zertifizierte Fachfirma</td>
            </tr>
        </tbody>
    </table>;
};

export default TableForm1;
